import {
  DEFAULT_CURRENCY_LIST_SUCCESS,
  DEFAULT_CURRENCY_LIST_FAILED,
  DEFAULT_CURRENCY_LIST_INVALID_REQUEST,
  DEFAULT_CURRENCY_LIST_INVALID_TOKEN,
  RESET_DEFAULT_CURRENCY_LIST,
  LOADING_DEFAULT_CURRENCY_LIST,
} from "../types";

const initialState = {
  isLoading: false,
  invalidToken: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DEFAULT_CURRENCY_LIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        invalidToken: false,
        invalidRequest: false,
        failed: false,
        networkError: "",
      };

    case DEFAULT_CURRENCY_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidToken: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload,
      };
    case DEFAULT_CURRENCY_LIST_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidToken: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload,
      };
    case DEFAULT_CURRENCY_LIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidToken: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
      };
    }

    case DEFAULT_CURRENCY_LIST_INVALID_TOKEN:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidToken: true,
        success: false,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
      };

    case RESET_DEFAULT_CURRENCY_LIST:
      return (state = initialState);

    default:
      return state;
  }
};
